import React from 'react';
import { InputGroup, InputGroupText } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the guide; each part uses its own slice of it */
import styles from './MailboxGuide.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface GuideInputProps {
  id: string;
  label: string;
  icon: IconDefinition;
  value: string;
  onChange: (value: string) => void;
  type?: 'text' | 'email';
  autoComplete?: string;
  placeholder?: string;
  maxLength?: number;
  inputRef?: React.Ref<HTMLInputElement>;
}

/** One field of the "Which email" step with its lead icon (design outreach-v2 p1 `.fld`). */
const GuideInputComponent: React.FC<GuideInputProps> = ({
  id,
  label,
  icon,
  value,
  onChange,
  type = 'text',
  autoComplete,
  placeholder,
  maxLength,
  inputRef,
}) => (
  <div className="d-flex flex-column gap-2">
    <label className="form-label small fw-semibold mb-0" htmlFor={id}>
      {label}
    </label>
    <InputGroup className={styles.field}>
      <InputGroupText aria-hidden="true">
        <FontAwesomeIcon icon={icon} fixedWidth />
      </InputGroupText>
      <input
        id={id}
        ref={inputRef}
        type={type}
        className="form-control"
        value={value}
        autoComplete={autoComplete}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={(event) => onChange(event.target.value)}
      />
    </InputGroup>
  </div>
);

export const GuideInput = TypedMemo(GuideInputComponent);
